import {
  DeleteCustomTimeRangeDocument,
  DeleteCustomTimeRangeMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteCustomTimeRange = () => {
  const [deleteTimeRange, { loading }] = useMutation(DeleteCustomTimeRangeDocument, {
    extractorFn: (data) => data.attendanceMutations.bulkDeleteAttendanceCustomTimeRange,
  })

  const deleteRange = (variables: DeleteCustomTimeRangeMutationVariables) => {
    return deleteTimeRange({
      variables,
      update(cache) {
        variables.ids.forEach((id) => {
          cache.evict({ id: cache.identify({ id: id, __typename: 'AttendanceCustomTimeRange' }) })
        })
      },
    })
  }

  return {
    loading,
    deleteRange,
  }
}
